import { useEffect, useRef, useState } from 'react';
import { API, axiosInstance, useAuth } from '../App';
import { getAdminPortalUrl } from '../utils/subdomain';

function OwnerRegistration({ user }) {
  const [organizations, setOrganizations] = useState([]);
  const [selected, setSelected] = useState('');
  const [attempted, setAttempted] = useState(false);
  const [clientId, setClientId] = useState('');
  const [error, setError] = useState('');
  const active = useRef(true);
  const busy = useRef(false);
  const validApi = ['https://cinch-sports-hq-staging-staging.up.railway.app/api', 'https://api.sporthouse.ai/api'].includes(API);
  useEffect(() => {
    active.current = true;
    if (validApi) axiosInstance.get('/developer/apps/mcp-owned-organizations').then(({data}) => {
      if (!active.current) return;
      if (!Array.isArray(data.organizations) || data.organizations.some(org => !org || typeof org.org_id !== 'string' || !org.org_id || typeof org.name !== 'string')) {
        setError('Owned organizations unavailable.'); return;
      }
      setOrganizations(data.organizations);
    }).catch(() => { if (active.current) setError('Owned organizations unavailable.'); });
    return () => { active.current = false; };
  }, [validApi]);
  const register = async () => {
    if (busy.current || !organizations.some(org => org.org_id === selected)) return;
    busy.current = true; setAttempted(true);
    try {
      const {data:current} = await axiosInstance.get('/auth/me');
      if (!active.current) return;
      if (current.user_id !== user.user_id || current.role !== 'super_admin') throw new Error('Session changed');
      const {data} = await axiosInstance.post(`/developer/apps/mcp-owned/${encodeURIComponent(selected)}`, {
        name:'Sporthouse MCP', description:'Read-only Sporthouse MCP program access.',
        authority_policy:'mcp_session_v1', expected_org_id:selected, scopes:['programs:read'],
        redirect_uri:`${API}/mcp/callback`, webhook_url:null, webhook_events:[],
      });
      if (!active.current) return;
      if (typeof data.app?.client_id !== 'string' || !/^client_[a-zA-Z0-9_-]+$/.test(data.app.client_id)) throw new Error('Unconfirmed');
      setClientId(data.app.client_id);
    } catch (_) { if (active.current) setError('Registration could not be confirmed. Reload before further action.'); }
  };
  if (!validApi) return <p>MCP registration unavailable for this API.</p>;
  return <main className="mx-auto max-w-2xl space-y-4 p-8">
    <h1>Register Sporthouse MCP for an owned organization</h1>
    <p>Only current persisted ownership authorizes registration. No role or organization context switch is performed. Support sessions cannot register MCP applications.</p>
    <p>Registration grants no access. Platform-owner consent and connection acceptance remain pending; MCP must remain disabled.</p>
    <label>MCP organization<select value={selected} disabled={attempted} onChange={event=>setSelected(event.target.value)}>
      <option value="">Select intended organization</option>
      {organizations.map(org=><option key={org.org_id} value={org.org_id}>{org.name}</option>)}
    </select></label>
    <button disabled={attempted || !selected} onClick={register}>Register MCP client</button>
    {error && <p role="alert">{error}</p>}
    {clientId && <p role="status">MCP client registered: {clientId}. No program access granted.</p>}
    <a href={getAdminPortalUrl('/platform/dashboard')}>Return to platform dashboard</a>
  </main>;
}
export default function PlatformMcpRegistration() {
  const {user} = useAuth();
  if (user?.role !== 'super_admin' || !user.user_id) return null;
  return <OwnerRegistration key={user.user_id} user={user}/>;
}
